import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import humanFormat from 'human-format';

const green = '#49b485';
const red = '#e74b36';
const Triangle = styled.span`
  display: block;
  margin-right: 8px;
  width: 0;
  height: 0;
  ${props => (!props.large ? `
    border-right: 3px solid transparent;
    border-left: 3px solid transparent;
    ${props.value > 0 ? `
      border-bottom: 5.2px solid ${green};
    ` : `
      border-top: 5.2px solid ${red};
    `};
  ` : `
    border-right: 4.7px solid transparent;
    border-left: 4.7px solid transparent;
    ${props.value > 0 ? `
      border-bottom: 8.1px solid ${green};
    ` : `
      border-top: 8.1px solid ${red};
    `};
  `)};
`;

const Num = styled.span`
  ${props => (props.large ? `
    font: ${props.theme.fontWeightBold} 19px/23px ${props.theme.fontFamilyBody};
  ` : `
    font: ${props.theme.fontWeightBold} 16px/20px ${props.theme.fontFamilyBody};
  `)};
  text-transform: uppercase;
  color: ${props => (props.value > 0 ? green : red)};
`;

const readble = d => humanFormat(d, { decimals: 1, separator: '' });

export default function Diff({ value, large, suffix }) {
  return (
    <>
      <Triangle value={value} large={large} />
      <Num value={value} large={large}>
        {readble(Math.abs(value))}
        {suffix}
      </Num>
    </>
  );
}

Diff.propTypes = {
  value: PropTypes.number.isRequired,
  large: PropTypes.bool,
  suffix: PropTypes.string,
};

Diff.defaultProps = {
  large: false,
  suffix: null,
};
